import { render, staticRenderFns } from "./ordersListDetailTable.vue?vue&type=template&id=3fc633c3&scoped=true"
import script from "./ordersListDetailTable.vue?vue&type=script&lang=js"
export * from "./ordersListDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListDetailTable.vue?vue&type=style&index=0&id=3fc633c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc633c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc633c3')) {
      api.createRecord('3fc633c3', component.options)
    } else {
      api.reload('3fc633c3', component.options)
    }
    module.hot.accept("./ordersListDetailTable.vue?vue&type=template&id=3fc633c3&scoped=true", function () {
      api.rerender('3fc633c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderManagement/components/ordersListDetailTable.vue"
export default component.exports